import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetHeadquarter } from 'src/app/models/headquarter/getHeadquarter';
import { GetGateway } from 'src/app/models/gateway/getGateway';

@Injectable({
  providedIn: 'root'
})
export class ShiftService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Shift';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetGateway> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetGateway>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  getListAll(idEnterprise: number = 0, idHeadquarter: number = 0): Observable<GetGateway> {
    return this.httpClient.get<GetGateway>(`${this.REQUEST_URL}/enterprise/${idEnterprise}/headquarter/${idHeadquarter}`);
  }

  create(data: any): Observable<any>{
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }

  update(data: any): Observable<any>{
    return this.httpClient.put<any>(`${this.REQUEST_URL}`,data);
  }

  delete(id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/` + id);
  }

  updateSettingGateway(data: any): Observable<any>{
    return this.httpClient.put<any>(`${this.REQUEST_URL}/paneliot`,data);
  }
}
